import React, { FunctionComponent } from 'react';
import { SerializedError } from '@reduxjs/toolkit';
import { NextRouter, useRouter } from 'next/router';

import { CTAButton } from 'src/components/atoms/CTAButton';
import { TextButton } from 'src/components/atoms/TextButton';
import { styles as modalStyles } from 'src/components/molecules/Modal';
import { FILTER_CONTROLS_CLOSE } from '../constants/copy';
import {
  FILTER_CONTROLS_RESET_BUTTON,
  FILTER_CONTROLS_VIEW_RESULTS_BUTTON,
} from '../constants/elementIds';
import * as styles from '../styles/FilterControls.styles';

export interface Props {
  resetText: string;
  isDisabled?: boolean;
  isLoading: boolean;
  totalSelectedFilterOptionsCount: number;
  totalProducts: number;
  onViewResults: VoidFunction;
  onReset: (router: NextRouter) => void;
  error?: SerializedError | null;
}
export const FilterControls: FunctionComponent<Props> = ({
  resetText,
  isDisabled,
  isLoading,
  totalSelectedFilterOptionsCount,
  totalProducts,
  onViewResults,
  onReset,
  error,
}: Props) => {
  const router = useRouter();

  return (
    <div css={modalStyles.modalSectionControls} aria-hidden={isDisabled}>
      <TextButton
        id={FILTER_CONTROLS_RESET_BUTTON}
        testId={FILTER_CONTROLS_RESET_BUTTON}
        css={styles.resetButton}
        isDisabled={isDisabled}
        onClick={(e) => {
          e.preventDefault();
          onReset(router);
        }}
      >
        {resetText}
      </TextButton>
      <CTAButton
        id={FILTER_CONTROLS_VIEW_RESULTS_BUTTON}
        testId={FILTER_CONTROLS_VIEW_RESULTS_BUTTON}
        isDisabled={isDisabled}
        onClick={onViewResults}
        isLoading={isLoading}
      >
        {totalSelectedFilterOptionsCount > 0 && !error
          ? `View ${totalProducts} products`
          : FILTER_CONTROLS_CLOSE}
      </CTAButton>
    </div>
  );
};
